<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-toolbar
                    id="response-code-toolbar"
                    flat
                >
                    <v-row>
                        <v-col cols="6">
                            <v-toolbar-title> Response Codes </v-toolbar-title>
                        </v-col>
                        <v-col
                            cols="6"
                            class="text-right"
                        >
                            <AddResponseCode
                                model-type="Add"
                            />
                        </v-col>
                    </v-row>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row
            class="mt-0"
            :no-gutters="this.$vuetify.breakpoint.xs"
        >
            <v-col>
                <v-data-table
                    id="Response-code-table"
                    :headers="_headers"
                    :items="companyResponseCodes"
                    class="elevation-1 mx-2"
                    fixed-header
                    item-key="layer_id"
                    dense
                >
                    <template v-slot:[`item.completes`]="{ item }">
                        {{ item.completes ? "YES" : "NO" }}
                    </template>
                    <template v-slot:[`item.design`]="{ item }">
                        {{ item.design ? "YES" : "NO" }}
                    </template>
                    <template v-slot:[`item.complex_project`]="{ item }">
                        {{ item.complex_project ? "YES" : "NO" }}
                    </template>
                    <template v-slot:[`item.send_pr_center`]="{ item }">
                        {{ item.send_pr_center ? "YES" : "NO" }}
                    </template>
                    <template v-slot:[`item.send_pr_excavator`]="{ item }">
                        <div v-if="hasExcavatorResponse">
                            {{ item.send_pr_excavator ? "YES" : "NO" }}
                        </div>
                    </template>
                    <template v-slot:[`item.edit`]="{item}">
                        <AddResponseCode
                            :response-details="item"
                            model-type="Edit"
                        />
                    </template>
                    <template v-slot:[`item.delete`]="{ item }">
                        <DeleteResponseCode
                            model-type="DeleteIcon"
                            :response-code="item"
                        />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import AddResponseCode from './AddResponseCode';
import DeleteResponseCode from './DeleteResponseCode';
import { hasPermission } from '../../../utils/permissions';

export default {
    name: 'ResponseCodeList',
    components: {
        AddResponseCode,
        DeleteResponseCode
    },
    data: () => ({
        headers: [
            {
                text: 'Response Code',
                align: 'left',
                sortable: false,
                value: 'response_code',
            },
            {
                text: 'Description',
                align: 'left',
                sortable: false,
                value: 'description',
            },
            {
                text: 'Closes?',
                align: 'left',
                sortable: false,
                value: 'completes',
            },
            {
                text: 'Design?',
                align: 'left',
                sortable: false,
                value: 'design',
            },
            {
                text: 'Complex?',
                align: 'left',
                sortable: false,
                value: 'complex_project',
            },
            {
                text: '+R/Center?',
                align: 'center',
                sortable: false,
                value: 'send_pr_center',
            },
            {
                text: '+R to Excavator?',
                align: 'left',
                sortable: false,
                value: 'send_pr_excavator',
            },
            {
                text: 'Edit',
                align: 'center',
                value: 'edit',
                sortable: false,
            },
            {
                text: 'Delete',
                align: 'center',
                value: 'delete',
                sortable: false,
            },
        ],
    }),
    computed: {
        companyResponseCodes() {
            return this.$store.getters.companyResponseCodes;
        },
        hasExcavatorResponse() {
            return hasPermission('EXCAVATOR_RESPONSE');
        },
        _headers() {
            return this.headers.filter((header) => {
                // Hide the excavator response column if the user does not have the permission
                if (header.value === 'send_pr_excavator') {
                    return this.hasExcavatorResponse;
                }
                return true;
            });
        },
    },
};
</script>

<style>
#Response-code-table .v-data-table-header tr th {
    background-color: #f5f7fa;
}
</style>

